'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nl_NL = require('../../date-picker/locale/nl_NL');

var _nl_NL2 = _interopRequireDefault(_nl_NL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _nl_NL2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/nl_NL.tsx
 ** module id = 739
 ** module chunks = 1
 **/